/* Pensum — theme scripts */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- Reveal */

  var observer = null;

  function initReveal(scope) {
    var items = (scope || document).querySelectorAll('[data-animate]:not(.is-visible)');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }

    items.forEach(function (el) { observer.observe(el); });
  }

  /* ----------------------------------------------------------------- Toast */

  var toastTimer = null;

  function showToast(message) {
    var toast = document.getElementById('Toast');
    if (!toast) return;
    var text = toast.querySelector('[data-toast-text]');
    if (text) text.textContent = message;
    toast.hidden = false;
    window.requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.hidden = true; }, 400);
    }, 4200);
  }

  /* ------------------------------------------------------------ Cart count */

  function refreshCartCount() {
    return fetch(window.Theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return cart;
      })
      .catch(function () { /* silent */ });
  }

  /* ----------------------------------------------------------- Mobile menu */

  function initDrawer() {
    function drawer() { return document.getElementById('MenuDrawer'); }

    function close() {
      var el = drawer();
      if (el) el.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-menu-open]')) {
        event.preventDefault();
        var el = drawer();
        if (!el) return;
        el.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        var first = el.querySelector('a, button');
        if (first) first.focus();
      } else if (event.target.closest('[data-menu-close]')) {
        event.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  }

  /* ---------------------------------------------------------- Search modal */

  function initSearch() {
    function modal() { return document.getElementById('SearchModal'); }

    function close() {
      var el = modal();
      if (el) el.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-search-open]')) {
        event.preventDefault();
        var el = modal();
        if (!el) return;
        el.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        var input = el.querySelector('input[type="search"]');
        if (input) setTimeout(function () { input.focus(); }, 60);
      } else if (event.target.closest('[data-search-close]')) {
        event.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  }

  /* ------------------------------------------------------- Quantity widget */

  function initQuantity() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-qty-change]');
      if (!button) return;
      event.preventDefault();
      var wrap = button.closest('.quantity');
      if (!wrap) return;
      var input = wrap.querySelector('input');
      if (!input) return;
      var step = button.dataset.qtyChange === 'up' ? 1 : -1;
      var min = parseInt(input.min || '1', 10);
      var next = (parseInt(input.value, 10) || min) + step;
      if (next < min) next = min;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------------------------------------------------------- Produktbilder */

  function initGallery(scope) {
    var roots = (scope || document).querySelectorAll('[data-gallery]');

    roots.forEach(function (root) {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      var main = root.querySelector('[data-gallery-main]');
      if (!main) return;

      var lead = root.querySelector('[data-gallery-lead]');
      var track = root.querySelector('[data-gallery-track]');
      var navButtons = root.querySelectorAll('[data-gallery-scroll]');

      // Kachel und großes Bild tauschen die Plätze. So bleibt die Anordnung
      // 1–2–2 vollständig besetzt, statt beim Wechsel eine Lücke zu lassen.
      function swap(tile, reveal) {
        if (!tile || !tile.dataset.src || !lead) return;

        var image = tile.querySelector('img');

        var outgoing = {
          id: lead.dataset.mediaId,
          src: main.src,
          srcset: main.srcset,
          alt: main.alt
        };

        main.src = tile.dataset.src;
        if (tile.dataset.srcset) main.srcset = tile.dataset.srcset;
        main.alt = tile.dataset.alt || '';
        lead.dataset.mediaId = tile.dataset.mediaId || '';

        tile.dataset.mediaId = outgoing.id || '';
        tile.dataset.src = outgoing.src;
        tile.dataset.srcset = outgoing.srcset;
        tile.dataset.alt = outgoing.alt;

        // Die Kachel zeigt eine kleinere Fassung; das große Bild taugt dafür,
        // die Auswahl im srcset übernimmt der Browser.
        if (image) {
          image.src = outgoing.src;
          if (outgoing.srcset) image.srcset = outgoing.srcset;
        }

        // Beim Farbwechsel darf die Seite nicht springen — der Kunde schaut
        // gerade auf das große Bild. Deshalb wird nur die Kachelreihe
        // waagerecht nachgeführt, niemals das Fenster gescrollt.
        if (reveal && track && track.contains(tile)) {
          var ziel = tile.offsetLeft - (track.clientWidth - tile.clientWidth) / 2;
          var weit = track.scrollWidth - track.clientWidth;
          track.scrollTo({ left: Math.min(Math.max(0, ziel), weit), behavior: 'smooth' });
        }
      }

      root.addEventListener('click', function (event) {
        var tile = event.target.closest('[data-gallery-tile]');
        if (tile) swap(tile);
      });

      /* -------------------------------------------------- Blättern */

      function updateNav() {
        if (!track || !navButtons.length) return;
        var rest = track.scrollWidth - track.clientWidth;

        navButtons.forEach(function (button) {
          var back = parseInt(button.dataset.galleryScroll, 10) < 0;
          button.disabled = back ? track.scrollLeft < 2 : track.scrollLeft > rest - 2;
        });
      }

      if (track && navButtons.length) {
        navButtons.forEach(function (button) {
          button.addEventListener('click', function () {
            var direction = parseInt(button.dataset.galleryScroll, 10) || 1;
            track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
          });
        });

        track.addEventListener('scroll', updateNav);
        window.addEventListener('resize', updateNav);
        updateNav();
      }

      // Farbwechsel: Bild der gewählten Variante zeigen, sofern eines
      // hinterlegt ist. Ohne Variantenbild bleibt die aktuelle Ansicht stehen.
      document.addEventListener('pensum:variant', function (event) {
        if (!document.contains(root)) return;
        var mediaId = event.detail && event.detail.mediaId;
        if (!mediaId) return;
        // Liegt das Bild schon oben, ist nichts zu tun.
        if (lead && lead.dataset.mediaId === String(mediaId)) return;
        swap(root.querySelector('[data-gallery-tile][data-media-id="' + mediaId + '"]'), true);
      });
    });
  }

  /* ------------------------------------------------------- Variant picking */

  function initVariants(scope) {
    var roots = (scope || document).querySelectorAll('[data-variant-picker]');
    roots.forEach(function (root) {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      var dataEl = root.querySelector('[data-variant-json]');
      if (!dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var form = document.getElementById(root.dataset.formId);
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var priceHost = document.getElementById(root.dataset.priceId);
      var submit = form ? form.querySelector('[data-add-button]') : null;

      root.addEventListener('change', function () {
        var selected = Array.prototype.map.call(root.querySelectorAll('select'), function (s) { return s.value; });

        var match = variants.find(function (variant) {
          return selected.every(function (value, index) {
            return variant.options[index] === value;
          });
        });

        if (!match) {
          if (submit) {
            submit.setAttribute('aria-disabled', 'true');
            submit.textContent = window.Theme.strings.unavailable;
          }
          return;
        }

        if (idInput) idInput.value = match.id;

        document.dispatchEvent(new CustomEvent('pensum:variant', {
          detail: {
            variant: match,
            mediaId: match.featured_media ? match.featured_media.id : null
          }
        }));

        if (submit) {
          if (match.available) {
            submit.removeAttribute('aria-disabled');
            submit.textContent = window.Theme.strings.addToCart;
          } else {
            submit.setAttribute('aria-disabled', 'true');
            submit.textContent = window.Theme.strings.soldOut;
          }
        }

        if (priceHost) {
          var base = root.dataset.productUrl || window.location.pathname;
          var url = base + '?section_id=' + root.dataset.sectionId + '&variant=' + match.id;
          fetch(url)
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var parsed = new DOMParser().parseFromString(html, 'text/html');
              var fresh = parsed.getElementById(root.dataset.priceId);
              if (fresh) priceHost.innerHTML = fresh.innerHTML;
            })
            .catch(function () { /* silent */ });
        }

        if (history.replaceState) {
          var newUrl = new URL(window.location.href);
          newUrl.searchParams.set('variant', match.id);
          history.replaceState({}, '', newUrl.toString());
        }
      });
    });
  }

  /* ------------------------------------------------------ Flug zum Korb */

  // Die Zahl neben dem Warenkorb kurz aufziehen. Das ist die eigentliche
  // Bestätigung — der Flug darüber ist nur die Spur dorthin.
  function bumpCart() {
    var badge = document.querySelector('[data-cart-count]');
    if (!badge) return;
    badge.classList.remove('is-bumped');
    // Ohne Reflow startet dieselbe Animation beim zweiten Mal nicht neu.
    void badge.offsetWidth;
    badge.classList.add('is-bumped');
  }

  // Nach dem Hinzufügen fliegt ein kleines Abbild des Produkts zum
  // Warenkorb. Auf einer so ruhigen Seite merkt man sonst kaum, dass
  // überhaupt etwas passiert ist.
  function flyToCart(form) {
    var target = document.querySelector('[data-cart-count]');
    if (!target || reduceMotion) return bumpCart();

    // Der Flug startet am Kaufknopf — dort hat der Kunde gerade geklickt und
    // dorthin schaut er. Was fliegt, ist trotzdem das Produktbild, damit
    // erkennbar bleibt, was in den Warenkorb geht.
    var button = form && form.querySelector('[data-add-button]');
    var image = document.querySelector('[data-gallery-main]');
    var origin = button || image;
    if (!origin) return bumpCart();

    var from = origin.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width || !to.width) return bumpCart();

    var size = 76;
    var flyer = document.createElement('div');
    flyer.className = 'fly-to-cart';
    flyer.setAttribute('aria-hidden', 'true');

    if (image && (image.currentSrc || image.src)) {
      flyer.style.backgroundImage = 'url("' + (image.currentSrc || image.src) + '")';
    }

    flyer.style.left = (from.left + from.width / 2 - size / 2) + 'px';
    flyer.style.top = (from.top + from.height / 2 - size / 2) + 'px';
    document.body.appendChild(flyer);

    var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    var dy = (to.top + to.height / 2) - (from.top + from.height / 2);

    // Den Startwert erzwingen, damit der Browser die Änderung als Übergang
    // sieht. Bewusst über einen Umbruch statt über requestAnimationFrame:
    // dessen Rückrufe laufen nicht, solange die Seite nicht gezeichnet wird —
    // etwa wenn der Kunde gleich nach dem Klick den Tab wechselt.
    void flyer.offsetWidth;

    flyer.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(0.12)';
    flyer.style.opacity = '0.15';

    var beendet = false;
    function aufraeumen() {
      if (beendet) return;
      beendet = true;
      if (flyer.parentNode) flyer.parentNode.removeChild(flyer);
      bumpCart();
    }

    flyer.addEventListener('transitionend', aufraeumen);
    // Fällt das Ereignis aus — etwa weil der Reiter im Hintergrund liegt —
    // räumt der Zeitgeber auf, damit nichts kleben bleibt.
    setTimeout(aufraeumen, 900);
  }

  /* --------------------------------------------------------- Add to cart */

  function initProductForms() {
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-product-form]');
      if (!form) return;

      // Enthält die Bestellung ein hochgeladenes Motiv, muss das Formular
      // regulär abgeschickt werden — Dateien kann die Cart-AJAX-API nicht.
      if (form.dataset.nativeSubmit === 'true') return;

      event.preventDefault();

      var button = form.querySelector('[data-add-button]');
      var original = button ? button.textContent : '';
      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.textContent = '…';
      }

      var body = new FormData(form);

      fetch(window.Theme.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: body
      })
        .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) {
            showToast(result.data.description || result.data.message || window.Theme.strings.unavailable);
            return;
          }

          showToast(window.Theme.strings.added);
          flyToCart(form);

          // Hat der Konfigurator einen Aufpreis vermerkt, kommt er als eigene
          // Zeile hinterher — erst wenn der Hauptartikel wirklich drin ist.
          var extra = form.dataset.extraVariant;
          if (!extra) return refreshCartCount();

          var quantityInput = form.querySelector('input[name="quantity"]');
          var quantity = Math.max(1, parseInt(quantityInput ? quantityInput.value : '1', 10) || 1);
          var properties = {};
          if (form.dataset.extraNote) properties['_Gehört zu'] = form.dataset.extraNote;

          return fetch(window.Theme.routes.cartAdd + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(extra), quantity: quantity, properties: properties }] })
          })
            .catch(function () { /* stumm: der Hauptartikel liegt bereits im Warenkorb */ })
            .then(refreshCartCount);
        })
        .catch(function () { form.submit(); })
        .finally(function () {
          if (button) {
            button.removeAttribute('aria-disabled');
            button.textContent = original;
          }
        });
    });
  }

  /* -------------------------------------------------------------- Cart page */

  function initCartPage() {
    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-cart-quantity]');
      if (!input) return;
      var form = input.closest('form');
      if (form) form.submit();
    });
  }

  /* --------------------------------------------------------- Collection sort */

  function initSort() {
    document.addEventListener('change', function (event) {
      var select = event.target.closest('[data-sort-select]');
      if (!select) return;
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------------------------------------------------------------- Sharing */

  function initShare() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-share]');
      if (!button) return;
      event.preventDefault();
      var url = button.dataset.share || window.location.href;

      if (navigator.share) {
        navigator.share({ url: url, title: document.title }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          showToast(window.Theme.strings.copied);
        });
      }
    });
  }

  /* ------------------------------------------------------------------- Boot */

  function boot() {
    initReveal(document);
    initDrawer();
    initSearch();
    initQuantity();
    initGallery(document);
    initVariants(document);
    initProductForms();
    initCartPage();
    initSort();
    initShare();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initReveal(event.target);
    initGallery(event.target);
    initVariants(event.target);
  });
})();
